<div class="table-pages-showing">
  @if (lang == 'en') {
    <span>Showing</span>
    <span class="px-1 bold">{{ itemsPerPage * (currentPage - 1) + 1 }}</span>
    <span>-</span>
    <span class="bold">{{
      list.length > itemsPerPage * currentPage ? itemsPerPage * currentPage : list.length
    }}</span>
    <span class="px-1">of</span>
    <span class="bold">{{ list.length }}</span>
  }
  @if (lang == 'tr') {
    <span class="bold">{{ list.length }}</span>
    <span class="px-1">kayıttan</span>
    <span class="bold">{{ itemsPerPage * (currentPage - 1) + 1 }}</span>
    <span>-</span>
    <span class="bold">{{
      list.length > itemsPerPage * currentPage ? itemsPerPage * currentPage : list.length
    }}</span>
    <span class="px-1">gösteriliyor</span>
  }
  @if (lang == 'es') {
    <span>Mostrando</span>
    <span class="px-1 bold">{{ itemsPerPage * (currentPage - 1) + 1 }}</span>
    <span>-</span>
    <span class="bold">{{
      list.length > itemsPerPage * currentPage ? itemsPerPage * currentPage : list.length
    }}</span>
    <span class="px-1">de</span>
    <span class="bold">{{ list.length }}</span>
  }
</div>
